<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div
      class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between"
    >
      <div>
        <div class="flex items-center gap-1">
          <div
            hoverMenu
            hoverDelay="50"
            #hoverDirective="hoverMenu"
            [matMenuTriggerFor]="infoMenu"
          >
            <button mat-icon-button color="primary">
              <mat-icon
                svgIcon="heroicons_outline:exclamation-circle"
              ></mat-icon>
            </button>
          </div>
          <mat-menu
            [hasBackdrop]="false"
            [overlapTrigger]="false"
            class="w-full"
            #infoMenu="matMenu"
          >
            <div class="p-4">
              <p>
                Consulta el historial completo de solicitudes de apertura y
                extensión de límites de crédito. Visualiza estados, montos y
                detalles de aprobación.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Solicitudes de Crédito
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Visualiza y exporta el <b>reporte de solicitudes</b> de
          <b>apertura y extensión</b> de <b>crédito</b>.
        </div>
      </div>
      <!-- Botón de filtros de estado -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                    <app-status-filters
          [selectedStatuses]="selectedStatuses"
          [selectedCustomerType]="selectedCustomerType"
          [showStatus]="[1, 0, 6, 7, 8, 14]"
          [showCustomerType]="['BPT9002', 'BPT9001', 'BPT0001']"
          (selectionFilterApply)="getList()"
        >
        </app-status-filters>
                </div>
                <!-- Actions -->
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">

                    <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
                        (click)="onExportButtonPressed()" matTooltip="Exportar">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                        <span class="ml-2">Exportar</span>
                    </button>
                </div>
            </div>
    </div>

    <!-- Main Content -->
    <div
      class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent"
    >
      <div class="pt-1 mx-6">
        <app-smart-grid
          [data]="data"
          [columnDefs]="columnDefs"
          [config]="gridConfig"
          [loading]="isLoading"
          [totalRecords]="totalItems"
          (pageChanged)="onPageChange($event)"
          (sortChanged)="onSortChange($event)">
        </app-smart-grid>
      </div>
    </div>
  </div>

  <!-- Filters Sidebar -->
  <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">
    <app-filter-section title="Rango de fechas" [expanded]="true">
      <app-dates-filters
        [form]="form"
        [showDateCreationRange]="true"
        [showDateApprovalRange]="true"
      >
      </app-dates-filters>
    </app-filter-section>
    <app-filter-section
      title="Asesor comercial"
      [expanded]="false"
      (onExpanded)="onBusinessPartnersExpanded()"
    >
      <app-business-partners-filters
        [form]="form"
        [assignedUser]="true"
        [loadData]="loadBusinessPartnersData"
      >
      </app-business-partners-filters>
    </app-filter-section>
    <app-filter-section
      title="Solicitudes"
      [expanded]="false"
      (onExpanded)="onDocumentsExpanded()"
    >
      <app-documents-filters
        [form]="form"
        [requestType]="true"
        [loadData]="loadDocumentsData"
        (filterApply)="onFilter()"
      >
      </app-documents-filters>
    </app-filter-section>
  </app-filter>
</mat-sidenav-container>
